export const SAFE_AREA_TOP = "var(--br-safe-area-top)";

export const getSafeAreaTop = () => SAFE_AREA_TOP;